import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { platformSelect } from '@bubble-ui/util-platform';
export var getCommonStyleSheet = specificButtonRoundStyles => _ref => {
  var _designContext$get;
  var {
    designContext,
    disabled,
    hovered,
    isMedium,
    isSmall,
    labelWidth,
    loading,
    pressed
  } = _ref;
  var {
    variant
  } = specificButtonRoundStyles();
  var buttonSize = isSmall ? 'small' : isMedium ? 'medium' : 'default';
  var colorTokenArgs = {
    interactiveState: disabled ? 'disabled' : loading ? 'default' : pressed ? 'pressed' : hovered ? 'hovered' : 'default',
    variant
  };
  var backgroundColor = designContext.get('base-button-round/background-color', colorTokenArgs).toString();
  var borderColor = (_designContext$get = designContext.get('base-button-round/border-color', colorTokenArgs)) === null || _designContext$get === void 0 ? void 0 : _designContext$get.toString();
  var focusBorderColor = designContext.get('base-button-round/focus-border-color', colorTokenArgs).toString();
  var labelTextColor = designContext.get('base-button-round/label-text-color', colorTokenArgs).toString();
  var baseButtonRoundBorderRadius = designContext.get('base-button-round/corner-radius').pixelValue;
  var borderWidth = borderColor ? 1 : 0;
  var size = designContext.get('base-button-round/size', {
    buttonSize
  }).pixelValue;
  var radius = size / 2;
  return {
    borderStyle: {
      height: size,
      width: size,
      position: 'absolute',
      borderWidth,
      borderColor,
      borderRadius: baseButtonRoundBorderRadius,
      transition: 'border-color .2s ease'
    },
    boundaryStyle: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: labelWidth || size
    },
    focusStyle: _objectSpread({
      position: 'absolute',
      top: -4,
      left: -4,
      right: -4,
      bottom: -4,
      width: size + 8,
      height: size + 8,
      borderRadius: baseButtonRoundBorderRadius,
      borderWidth: 2,
      borderColor: focusBorderColor,
      borderStyle: 'solid',
      transition: 'border-color .2s ease'
    }, labelWidth ? {
      maxWidth: labelWidth
    } : {}),
    iconStyle: {
      colorToken: 'base-button-round/icon-color',
      colorTokenArgs
    },
    iconWrapperStyle: _objectSpread({
      position: 'absolute'
    }, loading && isSmall ? {
      paddingBottom: radius - 6,
      paddingLeft: radius - 6,
      paddingRight: radius - 6,
      paddingTop: radius - 6
    } : {
      paddingBottom: radius - 10,
      paddingLeft: radius - 10,
      paddingRight: radius - 10,
      paddingTop: radius - 10
    }),
    loaderProps: {
      UNSAFE_colorToken: 'base-button-round/icon-color',
      UNSAFE_colorTokenArgs: colorTokenArgs,
      small: isSmall
    },
    rootStyle: {
      height: size,
      width: size,
      backgroundColor,
      borderRadius: baseButtonRoundBorderRadius,
      position: 'relative',
      transition: 'background-color .2s ease'
    },
    textStyle: _objectSpread(_objectSpread({
      color: labelTextColor
    }, designContext.get('base-button-round/label-text-style').styles()), {}, {
      paddingTop: 4,
      flexShrink: 0,
      textAlign: 'center'
    }, platformSelect({
      web: {
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: '2',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        overflow: 'hidden',
        WebkitFontSmoothing: 'antialiased'
      },
      native: {}
    })),
    textWrapperStyle: {
      maxWidth: labelWidth,
      paddingTop: 1
    },
    touchableStyle: {
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      border: 'none',
      cursor: disabled || loading ? 'auto' : 'pointer',
      outline: 0,
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString(),
      minHeight: size,
      maxWidth: labelWidth || size
    }
  };
};
//# sourceMappingURL=commonStyles.js.map